/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import "../css/settings.css";

import "../css/instruction.css";
import { Spinner } from "@shopify/polaris";
import config from "../config/config";

class HandleRequest extends React.Component {
  componentDidMount = () => {
    window.opener.postMessage({
      type: "paypalConnected",
      success: true,
      code: config.code,
    });
    window.close();
  };
  render() {
    return (
      <div id="i_loading_page_2">
        <Spinner size="large" color="teal" />
      </div>
    );
  }
}

export default HandleRequest;
